var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "vxsqik8qba",
    d: "M9.875 3l1.574 1.574-1.98 1.98.977.977 1.98-1.98L14 7.125V3H9.875zm-2.75 0H3v4.125l1.574-1.574 3.239 3.23V14h1.375V8.218L5.55 4.574 7.125 3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-590 -479) translate(570 245) translate(16 230.703) translate(4 4.09)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mdzp864syb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vxsqik8qba"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#09B15B",
    mask: "url(#mdzp864syb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommunity);
export default __webpack_public_path__ + "static/media/icon-community.037ffe08fafaeddc4b7ceb0c6fa85d11.svg";
export { ForwardRef as ReactComponent };